import { client } from '../client';
import { IGMConversation } from './types/IGMConversation';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { UserRoleName } from '../identity/types/UserProfile';

export const getConversation = async (
  sid: string,
  includeParticipants = true,
  userRole?: string,
): Promise<IGMConversation> => {
  if (!sid) {
    return Promise.reject(new Error('SID is required'));
  }

  const prefix = getStaffScopedApiPrefix(userRole);
  if (prefix) {
    const { data } = await client.get(`${prefix}/conversations/sid/${sid}?include_participants=${includeParticipants}`);
    return data;
  }
  try {
    const { data } = await client.get(`/conversations/sid/${sid}?include_participants=${includeParticipants}`);
    return data;
  } catch (error: any) {
    if ((!userRole || userRole === UserRoleName.Collector) && error?.response?.status === 403) {
      const collectorPrefix = getStaffScopedApiPrefix(UserRoleName.Collector);
      const { data } = await client.get(
        `${collectorPrefix}/conversations/sid/${sid}?include_participants=${includeParticipants}`,
      );
      return data;
    }
    throw error;
  }
};
